import { AsyncPipe, UpperCasePipe } from '@angular/common'
import { afterNextRender, ChangeDetectionStrategy, Component, inject, Injector } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { map, Observable } from 'rxjs'

import { FOOTER_DATA } from 'app/core/cms/footer-data.token'
import { CURRENT_LANG } from 'app/core/i18n/language.token'
import { IS_PREVIEW } from 'app/core/is-preview.token'
import { MetaService } from 'app/core/meta/meta.service'
import { CookieNotificationService, importCookieNotificationService } from 'app/features'
import { extendLangItems, ExtLangItem } from 'app/utils/extend-lang-items.function'

import { CmsIdDirective } from '../cms-id.directive'
import { CmsLinkDirective } from '../cms-link/cms-link.directive'
import { IconButtonComponent } from '../icon-button/icon-button.component'
import { NewsletterSubscriptionComponent } from '../newsletter-subscription/newsletter-subscription.component'
import { LexicalRichTextDirective } from '../richtext/lexical-rich-text.directive'
import { IconComponent } from '../svg/icon.component'
import { TranslatePipe } from '../translate.pipe'

@Component({
  selector: 'pai-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [
    AsyncPipe,
    UpperCasePipe,
    ReactiveFormsModule,
    IconComponent,
    IconButtonComponent,
    TranslatePipe,
    NewsletterSubscriptionComponent,
    CmsIdDirective,
    CmsLinkDirective,
    LexicalRichTextDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.role]': '"contentinfo"',
  },
})
export class FooterComponent {
  readonly languages$: Observable<ExtLangItem[] | null>
  readonly footer = inject(FOOTER_DATA)
  private readonly currentLanguage = inject(CURRENT_LANG)

  constructor() {
    const injector = inject(Injector)
    const isPreview = inject(IS_PREVIEW)

    this.languages$ = inject(MetaService).altUrls$.pipe(
      map(extendLangItems.bind(void 0, this.footer.languages, this.currentLanguage)),
    )

    afterNextRender(() => {
      const fn = (s: CookieNotificationService) =>
        s.check(this.footer.cookieMessage as any, 'CookieNotification.Consent', isPreview)
      void importCookieNotificationService(injector).then(fn)
    })
  }
}
